import { lazy } from 'react'

import generateRouterDetail from 'utils/helpers/generateRouterDetail'

import {
  MasterLoadingDockRBAC,
  MasterTimeSlotRBAC,
  InboundScheduleRBAC,
  InboundScheduleUpsertRBAC,
} from './rbac'

const LoadingDock = lazy(() => import('../pages/LoadingDock'))
const InboundSchedule = lazy(() => import('../pages/InboundSchedule'))
const InboundScheduleAdd = lazy(() => import('../pages/InboundScheduleAdd'))
const MasterTimeSlot = lazy(() => import('../pages/MasterTimeSlot'))

export const LoadingDockRouter: RouterFeatureInterface<
  'LoadingDockRouter',
  '/dashboard/loading-dock'
> = {
  name: 'LoadingDockRouter',
  Component: LoadingDock,
  path: '/dashboard/loading-dock',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterLoadingDockRBAC.pageID,
}

export const MasterTimeSlotRouter: RouterFeatureInterface<
  'MasterTimeSlotRouter',
  '/dashboard/master-time-slot'
> = {
  name: 'MasterTimeSlotRouter',
  Component: MasterTimeSlot,
  path: '/dashboard/master-time-slot',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: MasterTimeSlotRBAC.pageID,
}

export const InboundScheduleRouter: RouterFeatureInterface<
  'InboundScheduleRouter',
  '/dashboard/inbound-schedule'
> = {
  name: 'InboundScheduleRouter',
  Component: InboundSchedule,
  path: '/dashboard/inbound-schedule',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: InboundScheduleRBAC.pageID,
}

const InboundScheduleAddRouter: RouterFeatureInterface<
  'InboundScheduleAddRouter',
  '/dashboard/inbound-schedule/:type'
> = {
  name: 'InboundScheduleAddRouter',
  Component: InboundScheduleAdd,
  path: '/dashboard/inbound-schedule/:type',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: InboundScheduleUpsertRBAC.pageID,
}

const InboundScheduleEditAndDetailRouter: RouterFeatureInterface<
  'InboundScheduleEditAndDetailRouter',
  '/dashboard/inbound-schedule/:type/:id'
> = {
  name: 'InboundScheduleEditAndDetailRouter',
  Component: InboundScheduleAdd,
  path: '/dashboard/inbound-schedule/:type/:id',
  routeType: 'PRIVATE',
  allowedRoles: [],
  isDashboard: true,
  rbacPageID: InboundScheduleUpsertRBAC.pageID,
}

const CapacityHandlerRouter = [
  LoadingDockRouter,
  InboundScheduleRouter,
  InboundScheduleAddRouter,
  InboundScheduleEditAndDetailRouter,
  MasterTimeSlotRouter,
]

export const CapacityHandlerRouterDetail = generateRouterDetail(CapacityHandlerRouter)

export default CapacityHandlerRouter
